enum Page {
  Empty, NewCommitment, Commitment, EditCommitment, PostPoneHearing
}

export default Page;
